import { handlingCollegeErrors } from "./handling-college-errors-helpers";
import { BASE_URL_ONBOARDING } from "./index";
import { requestGetWithTemplate } from "./service-request-template";
import { GA_EVENTS } from "./tracker/ga.types";
import { CollegeStatusResponse } from "./types/college.entity";

export const getCollegeStatusByUserIdService = async ({
  userId,
}: {
  userId: string;
}) => {
  return requestGetWithTemplate<CollegeStatusResponse>({
    url: `${BASE_URL_ONBOARDING}/onboardings/campaigns/pre-ini/${userId}?COLEGIOS`,
    errorUrl: `in the get /api/v1/onboardings/campaigns/pre-ini/${userId}`,
    onHttpErrorMessage: "Error in the get college status by userId",
    onUnknownErrorLogMessage: `Unknown error in the get /api/v1/onboardings/campaigns/pre-ini/${userId}`,
    emptyData: {} as CollegeStatusResponse,
    handleError: handlingCollegeErrors,
    errorEventName: GA_EVENTS.ERRORS.REQUEST_COLLEGE_STATUS,
  });
};
